import React, { useState } from "react";
import { motion } from "framer-motion";
import { springVariants, springViewport } from '../utils/framerVariants';

const ReadMore = ({ data }) => {

  const isGerman = typeof window !== 'undefined' && window.location.pathname.includes('/de/');

  const [open, setOpen] = useState(false);
  const toggleContent = () => {
    setOpen(!open);
  };

  return (
    <article className="container mx-auto max-w-6xl lg:max-w-7xl 2xl:max-w-8xl mb-16 md:mb-24 lg:mb-32 xl:mb-48 px-4 md:px-24 lg:px-24">
      <motion.div
        variants={springVariants}
        initial="invisible"
        whileInView="visible"
        viewport={springViewport}
        className="richtextreadmore flex flex-col space-y-4"
      >
        {data.Headline && <div className="text-center" dangerouslySetInnerHTML={{ __html: data.Headline }} />}
        {data.Text &&
          <div
            className={`mt-8 readMoreContent ${open ? "open" : ""}`}
            dangerouslySetInnerHTML={{ __html: data.Text }}
          />
        }
        <p className="flex items-center justify-center">
          {isGerman &&
            <>
              {open ? (
                <a className="inline-flex readMoreToggle text-center font-bold cursor-pointer text-headline-md tracking-headline-md leading-1 mt-8" onClick={toggleContent}>
                  Verstecken
                </a>
              ) : (
                <a className="inline-flex readMoreToggle text-center font-bold cursor-pointer text-headline-md tracking-headline-md leading-1" onClick={toggleContent}>
                  Weiterlesen
                </a>
              )}
            </>
          }
          {!isGerman &&
            <>
              {open ? (
                <a className="inline-flex readMoreToggle text-center font-bold cursor-pointer text-headline-md tracking-headline-md leading-1 mt-8" onClick={toggleContent}>
                  Hide
                </a>
              ) : (
                <a className="inline-flex readMoreToggle text-center font-bold cursor-pointer text-headline-md tracking-headline-md leading-1" onClick={toggleContent}>
                  Read More
                </a>
              )}
            </>
          }
        </p>
      </motion.div>
    </article>
  );
};

export default ReadMore;
